module.exports = __webpack_public_path__ + "img/signature-ambre.f1f95e60.png";